// src/dashboard/pages/teacher/ToDoList/components/TaskCard.jsx

import React from "react";
import { FaEdit, FaGripVertical, FaTrash } from "react-icons/fa";

import {
  getTaskUser,
  getUserAvatarSrc,
  getUserDisplayName,
  STATUS_META,
  STATUS_ORDER,
} from "../utils/toDoListDashboardUtils";

export default function TaskCard({
  task,
  deletingId,
  onEdit,
  onDelete,
  onChangeStatus,
  onDragStart,
}) {
  const meta = STATUS_META[task?.statut] || STATUS_META["A faire"];
  const user = getTaskUser(task);

  return (
    <article
      className={`group relative overflow-hidden rounded-2xl border ${meta.ring} bg-white p-4 pl-5 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:bg-slate-900/70`}
      draggable
      onDragStart={(event) => onDragStart(event, task)}
      role="article"
      aria-label={task?.titre || "Tâche"}
    >
      <span
        className={`absolute bottom-0 left-0 top-0 w-2 ${meta.accent}`}
        aria-hidden="true"
      />

      <div className="flex items-start gap-3">
        <img
          src={getUserAvatarSrc(user)}
          alt={getUserDisplayName(user)}
          onError={(event) => {
            event.currentTarget.src = "/img/user_avatar.jpg";
          }}
          className="h-11 w-11 shrink-0 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
        />

        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="truncate text-sm font-bold text-slate-900 dark:text-white">
                {getUserDisplayName(user)}
              </p>

              {task?.categorie ? (
                <span className="mt-1 inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-300">
                  {task.categorie}
                </span>
              ) : null}
            </div>

            <span className="mt-1 text-slate-300 transition group-hover:text-slate-500 dark:text-slate-700 dark:group-hover:text-slate-400">
              <FaGripVertical />
            </span>
          </div>
        </div>
      </div>

      {task?.titre ? (
        <h3 className="mt-3 text-[15px] font-bold leading-snug text-slate-900 dark:text-white">
          {task.titre}
        </h3>
      ) : null}

      {task?.contenu ? (
        <div className="mt-2 max-h-28 overflow-hidden text-sm leading-6 text-slate-600 dark:text-slate-300">
          <div dangerouslySetInnerHTML={{ __html: task.contenu }} />
        </div>
      ) : null}

      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:items-center">
        <span
          className={`inline-flex w-fit rounded-full px-2.5 py-1 text-[11px] font-bold ${meta.badge}`}
        >
          {task?.statut || "—"}
        </span>

        <select
          value={task?.statut || "A faire"}
          onChange={(event) => onChangeStatus(task, event.target.value)}
          className="w-full rounded-xl border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
          title="Changer le statut"
        >
          {STATUS_ORDER.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-4 flex items-center justify-end gap-2 border-t border-slate-100 pt-3 dark:border-slate-800">
        <button
          type="button"
          onClick={() => onEdit(task)}
          className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 hover:text-indigo-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
          title="Modifier"
        >
          <FaEdit />
        </button>

        <button
          type="button"
          onClick={() => onDelete(task)}
          disabled={deletingId === task.id}
          className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
          title="Supprimer"
        >
          <FaTrash />
        </button>
      </div>
    </article>
  );
}